/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SdsBackendFlavor {
    SdsClassic = 'SdsClassic',
    SdsSwift = 'SdsSwift'
}

export function SdsBackendFlavorFromJSON(json: any): SdsBackendFlavor {
    return SdsBackendFlavorFromJSONTyped(json, false);
}

export function SdsBackendFlavorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SdsBackendFlavor {
    return json as SdsBackendFlavor;
}

export function SdsBackendFlavorToJSON(value?: SdsBackendFlavor | null): any {
    return value as any;
}

